import React from 'react';
import { useEditItem2 } from "../../../../api/useNewItem"
import { EditorPlugin } from "../../slate/PowerEditorConfig";
import { FormGrid, JsonEditorTextarea, SimpleDialog } from '../../../primitives';
import { EditOutlined } from '@mui/icons-material';

export const useEditEditorAsJson = (blocks: any, setBlocks: (v: any) => void) => {
  const data = useEditItem2<{ text: string }>({
    save: async (item) => {
      const x = JSON.parse(item.text);
      setBlocks(x);
      return item;
    }
  });

  return {
    ...data,
    startEditing: () => {
      data.startEditing({ text: JSON.stringify(blocks) });
    }
  }
}

export const useEditEditorAsJsonPlugin = (blocks: any, setBlocks: (v: any) => void): EditorPlugin => {
  const data = useEditEditorAsJson(blocks, setBlocks);

  const dialog = (<>
    <SimpleDialog
      isOpen={data.isEditing}
      close={() => data.cancel()}
      dialogTitle={"JSON"}
      maxWidth="lg"
      submitOnModEnter
      save={data.save}>
        <FormGrid columns="1fr">
          <JsonEditorTextarea
            value={data.item?.text || ""}
            onChange={e => data.update({ text: e.target.value })}
            />
        </FormGrid>
    </SimpleDialog>
  </>);

  return {
      key: "json-edit",
      dialogs: dialog,
      commands: [{
          name: "edit json",
          invoke: editor => data.startEditing(),
          menu: { section: "insert-item", icon: <EditOutlined />, label: "Edit JSON" },
      }],
  };
}
